<template>
    <rkm-area
        no-margin-top
        title="Prescrições de medicamentos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.prescricoesMedicamentos"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{index}">
                        <rkm-row>
                            <rkm-col cols="12">
                                <strong>Prescrição</strong> {{index + 1}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{item}">
                        <rkm-list
                            :items="item.medicamentos"
                            class="p-2"
                            hide-filters
                            hide-pagination
                            item-cursor="default"
                        >
                            <template v-slot="{item}">
                                <rkm-row v-if="item.isManual">
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.descricao"
                                            label="Descrição"
                                        />
                                    </rkm-col>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.justificativa"
                                            label="Justificativa"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <template v-else>
                                    <rkm-row>
                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.material.descricao"
                                                label="Medicamento"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.material.viaAdministracao.nome"
                                                label="Via de administração"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.posologia"
                                                label="Posologia"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.isDoseUnica ? 'Sim' : 'Não'"
                                                label="Dose única"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row>
                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.isUsoContinuo ? 'Sim' : 'Não'"
                                                label="Uso contínuo"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.inicio"
                                                label="Início do tratamento"
                                            />
                                        </rkm-col>

                                        <rkm-col
                                            v-if="!item.isUsoContinuo"
                                            cols="3"
                                        >
                                            <Item
                                                :append-text="item.duracaoMedidaTempo ? item.duracaoMedidaTempo.nome : ''"
                                                :get-value="() => item.duracao"
                                                label="Duração"
                                            />
                                        </rkm-col>

                                        <rkm-col
                                            v-if="item.conclusao"
                                            cols="3"
                                        >
                                            <Item
                                                :get-value="() => item.conclusao"
                                                label="Conclusão do tratamento"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </template>

                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.recomendacoes"
                                            label="Recomendações"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <template v-if="!item.isManual && item.isTratamentoInterrompido">
                                    <rkm-row>
                                        <rkm-col cols="3">
                                            <Item
                                                :get-value="() => item.tratamentoInterrompidoEm"
                                                label="Tratamento interrompido"
                                            />
                                        </rkm-col>
                                    </rkm-row>

                                    <rkm-row>
                                        <rkm-col cols="12">
                                            <Item
                                                :get-value="() => item.tratamentoInterrompidoJustificativa"
                                                label="Justificativa do tratamento interrompido"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </template>
                            </template>
                        </rkm-list>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>